// import React, { useEffect, useState, useCallback } from "react";
// import { get } from "../../../lib/http";
// import { API } from "../../../config/api.js";
// import ReactPaginate from "react-paginate";
// import FancyLoader from "../../../components/FancyLoader.jsx";
// import {
//   FaMapMarkerAlt,
//   FaCalendarAlt,
//   FaDownload,
//   FaInfoCircle,
//   FaSearch,
//   FaTimes,
//   FaRegCopy,
//   FaCheck,
// } from "react-icons/fa";

// /* ---------------- helpers ---------------- */
// const inr = (n) => (typeof n === "number" ? `₹${n.toLocaleString("en-IN")}` : n || "—");
// const TZ = "Asia/Kolkata";

// function formatDT(
//   iso,
//   { mode = "preserveBackendWallTime", withTime = true, keepCalendarDate = false } = {}
// ) {
//   if (!iso) return "—";
//   const d = new Date(iso);

//   if (keepCalendarDate) {
//     // Date shown in UTC calendar (backend), time shown in IST
//     const date = new Intl.DateTimeFormat("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//       timeZone: "UTC",
//     }).format(d);

//     if (!withTime) return date;

//     const time = new Intl.DateTimeFormat("en-IN", {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//       timeZone: TZ,
//     }).format(d);

//     return `${date} • ${time}`;
//   }

//   // Default behavior: both parts same zone per mode
//   const timeZone = mode === "localIST" ? TZ : "UTC";

//   const date = new Intl.DateTimeFormat("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//     timeZone,
//   }).format(d);

//   if (!withTime) return date;

//   const time = new Intl.DateTimeFormat("en-IN", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//     timeZone,
//   }).format(d);

//   return `${date} • ${time}`;
// }

// function downloadBlob(blob, filenameFallback = "file.bin") {
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = filenameFallback;
//   document.body.appendChild(a);
//   a.click();
//   a.remove();
//   URL.revokeObjectURL(url);
// }
// function b64toBlob(b64, type) {
//   const bin = atob(b64);
//   const arr = new Uint8Array(bin.length);
//   for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
//   return new Blob([arr], { type });
// }

// /* ---------------- icon (ticket) ---------------- */
// function TicketIcon({ className = "h-6 w-6" }) {
//   return (
//     <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M4 4h16v4a2 2 0 0 1 0 4v4H4v-4a2 2 0 0 1 0-4V4z" />
//       <path d="M8 4v16M16 4v16" />
//     </svg>
//   );
// }

// export default function AllBookingList() {
//   const [bookings, setBookings] = useState([]);
//   const [selected, setSelected] = useState(null);

//   // Pagination
//   const [page, setPage] = useState(1); // 1-based
//   const [limit] = useState(12);
//   const [total, setTotal] = useState(0);
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [errMsg, setErrMsg] = useState("");

//   // Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");

//   // Copy state map to show "copied" feedback per booking
//   const [copiedMap, setCopiedMap] = useState({});

//   // Debounce search input (450ms)
//   useEffect(() => {
//     const t = setTimeout(() => setDebouncedSearch(searchTerm.trim()), 450);
//     return () => clearTimeout(t);
//   }, [searchTerm]);

//   // Reset to page 1 whenever user changes search (immediate)
//   useEffect(() => {
//     setPage(1);
//   }, [debouncedSearch]);

//   const fetchBookings = useCallback(async () => {
//     setLoading(true);
//     setErrMsg("");
//     try {
//       const raw = localStorage.getItem("bb_user");
//       const parsed = raw ? JSON.parse(raw) : null;
//       const userId = parsed?.id ?? null;
//       const token = parsed?.token ?? null;

//       if (!userId) {
//         setBookings([]);
//         setTotal(0);
//         setTotalPages(1);
//         setErrMsg("User not logged in.");
//         setLoading(false);
//         return;
//       }

//       // Build URL with pagination and optional search (q)
//       const qParam = debouncedSearch ? `&q=${encodeURIComponent(debouncedSearch)}` : "";
//       const url = `${API.booking.getAllBooking}?page=${page}&limit=${limit}&paginate=true${qParam}`;

//       const res = await get(url, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "application/json",
//         },
//       });

//       console.log(res, "fetchBookings response");
//       const arr = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
//       const meta = res?.meta || (res?.data?.meta ? res.data.meta : {});

//       const totalFromMeta =
//         Number(meta.total) || (Array.isArray(res) ? res.length : arr.length || 0);
//       const totalPagesFromMeta =
//         Number(meta.totalPages) || Math.max(1, Math.ceil(totalFromMeta / limit));
//       const pageFromMeta = Number(meta.page) || page;

//       setBookings(arr);
//       setTotal(totalFromMeta);
//       setTotalPages(totalPagesFromMeta);
//       if (pageFromMeta !== page) setPage(pageFromMeta);
//     } catch (e) {
//       console.error("fetchBookings error:", e);
//       setBookings([]);
//       setTotal(0);
//       setTotalPages(1);
//       setErrMsg(e?.message || "Failed to load bookings.");
//     } finally {
//       setLoading(false);
//     }
//   }, [page, limit, debouncedSearch]);

//   useEffect(() => {
//     fetchBookings();
//   }, [fetchBookings]);

//   const handlePageChange = ({ selected }) => {
//     const newPage = selected + 1;
//     if (newPage !== page) setPage(newPage);
//   };

//   async function downloadTicketPDF(bookingCode, eventName) {
//     try {
//       const token = JSON.parse(localStorage.getItem("bb_user") || "{}").token ?? null;
//       const newUrl = import.meta.env.VITE_API_BASE_URL;
//       const url = `${newUrl}/api/ticket/downloadTicketsAsPDF/${encodeURIComponent(
//         bookingCode
//       )}`;
//       const resp = await fetch(url, {
//         method: "POST",
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//       });

//       if (!resp.ok) {
//         const msg = await resp.text().catch(() => "");
//         throw new Error(`HTTP ${resp.status} ${msg}`);
//       }
//       const ct = (resp.headers.get("content-type") || "").toLowerCase();
//       let blob;
//       if (ct.includes("application/pdf")) blob = await resp.blob();
//       else if (ct.includes("application/json")) {
//         const data = await resp.json().catch(() => ({}));
//         if (data?.pdfBase64) blob = b64toBlob(data.pdfBase64, "application/pdf");
//         else if (data?.url) {
//           window.location.href = data.url;
//           return;
//         } else throw new Error("JSON received but no pdfBase64/url.");
//       } else blob = await resp.blob();

//       const safeEvent = (eventName || "ticket").replace(/\s+/g, "-").slice(0, 50);
//       downloadBlob(blob, `${safeEvent}-${bookingCode}.pdf`);
//     } catch (err) {
//       console.error("PDF download error:", err);
//       alert(err?.message || "Could not download PDF. Please try again.");
//     }
//   }

//   // Copy booking code to clipboard with small UI feedback
//   const copyBookingCode = async (code, id) => {
//     try {
//       if (!code) return;
//       await navigator.clipboard.writeText(code);
//       setCopiedMap((m) => ({ ...m, [id]: true }));
//       setTimeout(() => {
//         setCopiedMap((m) => {
//           const copy = { ...m };
//           delete copy[id];
//           return copy;
//         });
//       }, 1800);
//     } catch (e) {
//       console.error("copy failed", e);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-amber-50 via-white to-yellow-50">
//       <style>{`
//         .fade-in { animation: fadeIn .45s ease both; }
//         @keyframes fadeIn { from { opacity:.0; transform: translateY(6px) } to { opacity:1; transform: translateY(0) } }
//       `}</style>

//       {/* Header */}
//       <header className="sticky top-0 z-20 backdrop-blur supports-[backdrop-filter]:bg-white/75 bg-white/80 border-b border-white/70">
//         <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between">
//           <div className="flex items-center gap-2 text-slate-700 min-w-0">
//             <TicketIcon className="h-6 w-6 text-amber-600 shrink-0" />
//             <h1 className="text-lg md:text-2xl font-bold truncate">My Bookings</h1>
//           </div>

//           <div className="flex items-center gap-3">
//             {/* Search input in header (compact) */}
//             <div className="relative">
//               <input
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search events, codes, venue..."
//                 className="pl-9 pr-8 py-2 text-sm rounded-lg border border-slate-200 bg-white w-[220px] md:w-[300px] focus:outline-none focus:ring-2 focus:ring-amber-300"
//               />
//               <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
//               {searchTerm && (
//                 <button
//                   onClick={() => setSearchTerm("")}
//                   className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
//                   aria-label="Clear search"
//                 >
//                   <FaTimes />
//                 </button>
//               )}
//             </div>

//             <span className="text-[11px] md:text-xs text-slate-500 shrink-0">
//               Total: {total}
//             </span>
//           </div>
//         </div>
//       </header>

//       <main className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8">
//         {/* Info bar */}
//         <div className="mb-6 bg-white/90 backdrop-blur border border-white/60 rounded-2xl p-3 md:p-5 flex items-start gap-3 shadow">
//           <FaInfoCircle className="text-amber-600 mt-0.5 shrink-0" />
//           <p className="text-xs md:text-sm text-slate-700">
//             Access your M-Tickets anytime. Confirmed bookings show a download button for quick PDF access.
//             {debouncedSearch ? <span className="block mt-1 text-xs text-slate-500">Showing results for “<span className="font-semibold text-slate-700">{debouncedSearch}</span>”</span> : null}
//           </p>
//         </div>

//         {/* Loader */}
//         {loading && (
//           <div className="py-20 text-center">
//             <FancyLoader label="Loading bookings…" />
//           </div>
//         )}

//         {/* Error */}
//         {errMsg && !loading && (
//           <div className="mb-6 bg-rose-50/90 border border-rose-200 text-rose-700 rounded-2xl p-4">
//             {errMsg}
//           </div>
//         )}

//         {/* Grid */}
//         {!loading && !!bookings.length && (
//           <div
//             className="
//               grid gap-4 md:gap-6
//               grid-cols-1
//               sm:grid-cols-2
//               lg:grid-cols-3
//               xl:[grid-template-columns:repeat(4,minmax(0,1fr))]
//             "
//           >
//             {bookings.map((b, idx) => {
//               const status = b?.bookingStatus || "—";
//               const confirmed = status?.toLowerCase() === "confirmed";
//               const img = b?.eventId?.imageUrl || "";
//               const title = b?.eventId?.name || "Untitled Event";
//               const venue = b?.eventId?.venue?.name || "";
//               const city = b?.eventId?.venue?.city || "";
//               const state = b?.eventId?.venue?.state || "";
//               // Prefer event date from backend (no shift)
//               const eventDate = b?.eventId?.date || b?.eventDate || b?.createdAt;
//               const bookingCode = b?.bookingCode || "—";
//               const idKey = b?._id || b?.id || bookingCode || idx;

//               return (
//                 <article
//                   key={idKey}
//                   className="group bg-white rounded-2xl border border-slate-200/70 shadow-sm hover:shadow-xl transition-all overflow-hidden fade-in"
//                   style={{ animationDelay: `${idx * 35}ms` }}
//                 >
//                   {/* Image: use aspect to prevent jumpy heights on zoom */}
//                   <div className="relative w-full aspect-video overflow-hidden bg-gray-900">
//                     {img ? (
//                       <img
//                         src={img}
//                         alt={title}
//                         className="h-full w-full object-contain"
//                       />
//                     ) : (
//                       <div className="h-full w-full bg-gradient-to-br from-amber-100 to-yellow-100" />
//                     )}
//                     <div className="absolute inset-x-0 top-0 h-10 bg-gradient-to-b from-black/20 to-transparent" />
//                     <div className="absolute left-3 top-3 px-2.5 py-1 rounded-full text-[11px] font-semibold text-amber-900 bg-amber-300/90 border border-amber-400 shadow-sm">
//                       {status}
//                     </div>
//                   </div>

//                   <div className="p-4 flex flex-col gap-2 min-w-0">
//                     <h3 className="font-semibold text-slate-900 leading-snug line-clamp-1">
//                       {title}
//                     </h3>

//                     {/* Booking Code (inline) */}
//                     <div className="flex items-center gap-2 text-xs text-slate-600 mt-1">
//                       <div className="font-mono text-[12px] text-slate-700 truncate">
//                         {bookingCode}
//                       </div>
//                       <button
//                         onClick={() => copyBookingCode(bookingCode, idKey)}
//                         className="ml-1 inline-flex items-center gap-2 text-[11px] text-slate-500 hover:text-slate-800"
//                         title="Copy booking code"
//                       >
//                         {copiedMap[idKey] ? (
//                           <span className="inline-flex items-center gap-1 text-emerald-600">
//                             <FaCheck /> Copied
//                           </span>
//                         ) : (
//                           <span className="inline-flex items-center gap-1">
//                             <FaRegCopy /> Copy
//                           </span>
//                         )}
//                       </button>
//                     </div>

//                     <div className="text-xs text-slate-600 flex items-center gap-2 min-w-0 mt-2">
//                       <FaMapMarkerAlt className="text-amber-600 shrink-0" />
//                       <span className="truncate">
//                         {venue}
//                         {venue && (city || state) ? " — " : ""}
//                         {city}
//                         {city && state ? ", " : ""}
//                         {state}
//                       </span>
//                     </div>

//                     {/* DATE: keep backend calendar day, show time in IST */}
//                     <div className="text-xs text-slate-600 flex items-center gap-2 min-w-0">
//                       <FaCalendarAlt className="text-amber-600 shrink-0" />
//                       <span className="truncate">
//                         {formatDT(eventDate, { withTime: true, keepCalendarDate: true })}
//                       </span>
//                     </div>

//                     <div className="mt-2 flex items-center justify-between gap-3 flex-wrap">
//                       <div className="text-sm font-bold text-slate-900">
//                         {inr(b?.finalAmount)}
//                       </div>

//                       <div className="flex items-center gap-2 flex-wrap">
//                         {confirmed && (
//                           <button
//                             onClick={() => downloadTicketPDF(b?.bookingCode, title)}
//                             className="px-3 py-1.5 rounded-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white text-xs font-semibold shadow"
//                             title="Download Ticket PDF"
//                           >
//                             <span className="inline-flex items-center gap-1">
//                               <FaDownload /> PDF
//                             </span>
//                           </button>
//                         )}
//                         <button
//                           onClick={() => setSelected(b)}
//                           className="px-3 py-1.5 rounded-full border border-slate-200 hover:border-amber-300 bg-white hover:bg-amber-50 text-xs font-semibold text-slate-700"
//                         >
//                           View
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </article>
//               );
//             })}
//           </div>
//         )}

//         {/* Empty */}
//         {!loading && !bookings.length && !errMsg && (
//           <div className="bg-white border rounded-2xl p-6 md:p-10 text-center text-slate-600">
//             <div className="text-5xl md:text-6xl mb-3">🎟️</div>
//             <p className="font-semibold text-slate-800">No bookings found</p>
//             <p className="text-xs md:text-sm mt-1">
//               When you book an event, it will show up here.
//             </p>
//           </div>
//         )}

//         {/* Pagination (wrap on zoom) */}
//         {!loading && totalPages > 1 && (
//           <div className="mt-8">
//             <ReactPaginate
//               breakLabel="…"
//               nextLabel={
//                 <span className="px-3 py-2 rounded-lg border border-slate-200 bg-white hover:bg-amber-50 hover:border-amber-200 text-sm">
//                   Next ›
//                 </span>
//               }
//               previousLabel={
//                 <span className="px-3 py-2 rounded-lg border border-slate-200 bg-white hover:bg-amber-50 hover:border-amber-200 text-sm">
//                   ‹ Prev
//                 </span>
//               }
//               onPageChange={handlePageChange}
//               forcePage={Math.max(0, Math.min(totalPages - 1, page - 1))}
//               pageRangeDisplayed={5}
//               marginPagesDisplayed={1}
//               pageCount={totalPages}
//               containerClassName="flex items-center justify-center gap-1 md:gap-2 select-none flex-wrap"
//               pageClassName="group"
//               pageLinkClassName="px-3 py-2 rounded-lg border border-slate-200 bg-white hover:bg-amber-50 hover:border-amber-200 transition-colors text-sm font-medium"
//               breakClassName="px-2 text-sm"
//               activeClassName="selected"
//             />
//             <style>{`.selected a{background:#f59e0b!important;color:#fff!important;border-color:#f59e0b!important}`}</style>
//             <div className="mt-3 text-center text-xs text-slate-500">
//               Page {page} of {totalPages} • {total} total
//             </div>
//           </div>
//         )}
//       </main>

//       {/* Modal */}
//       {selected && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-3 md:p-4">
//           <div
//             className="absolute inset-0 bg-black/50"
//             onClick={() => setSelected(null)}
//           />
//           <div
//             className="
//               relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl
//               p-4 md:p-6
//               max-h-[85vh] overflow-y-auto
//             "
//           >
//             <button
//               onClick={() => setSelected(null)}
//               className="absolute top-3 right-3 text-slate-400 hover:text-slate-900"
//               aria-label="Close"
//             >
//               ✕
//             </button>

//             <div className="flex items-start gap-4 mb-6 min-w-0">
//               <div className="w-36 md:w-40 shrink-0">
//                 <div className="w-full aspect-video overflow-hidden rounded-lg">
//                   <img
//                     src={selected?.eventId?.imageUrl}
//                     alt={selected?.eventId?.name}
//                     className="h-full w-full object-contain"
//                   />
//                 </div>
//               </div>

//               <div className="min-w-0 flex-1">
//                 <h2 className="text-lg md:text-xl font-bold text-slate-900 truncate">
//                   {selected?.eventId?.name}
//                 </h2>
//                 <p className="text-xs md:text-sm text-slate-600 flex items-center gap-2 mt-1 min-w-0">
//                   <FaMapMarkerAlt className="text-amber-600 shrink-0" />
//                   <span className="truncate">
//                     {selected?.eventId?.venue?.name}
//                     {selected?.eventId?.venue?.name &&
//                       (selected?.eventId?.venue?.city ||
//                         selected?.eventId?.venue?.state)
//                       ? " — "
//                       : ""}
//                     {selected?.eventId?.venue?.city}
//                     {selected?.eventId?.venue?.city &&
//                       selected?.eventId?.venue?.state
//                       ? ", "
//                       : ""}
//                     {selected?.eventId?.venue?.state}
//                   </span>
//                 </p>
//                 {/* DATE in modal header: same rule */}
//                 <p className="text-[11px] md:text-xs text-slate-500 mt-1 flex items-center gap-2 min-w-0">
//                   <FaCalendarAlt className="text-amber-600 shrink-0" />
//                   <span className="truncate">
//                     {formatDT(selected?.eventId?.date, {
//                       withTime: true,
//                       keepCalendarDate: true,
//                     })}
//                   </span>
//                 </p>
//               </div>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 text-sm">
//               <Detail label="Booking Code" value={selected?.bookingCode} />
//               <Detail label="Booking Status" value={selected?.bookingStatus} />
//               <Detail label="Payment Status" value={selected?.paymentStatus} />
//               <Detail label="Refund Status" value={selected?.refundStatus} />
//               <Detail label="Payment Mode" value={selected?.paymentMode} />
//               <Detail
//                 label="Tickets"
//                 value={selected?.ticketCategories
//                   ?.map((t) =>
//                     `${t?.quantity} x ${typeof t?.categoryId === "string"
//                       ? t?.categoryId
//                       : t?.categoryId?.name || ""
//                     }`
//                   )
//                   .join(", ")}
//               />
//               <Detail label="Total Amount" value={inr(selected?.totalAmount)} />
//               <Detail label="GST" value={inr(selected?.gstAmount)} />
//               <Detail label="Convenience Fee" value={inr(selected?.convenienceFee)} />
//               <Detail
//                 label="Discount"
//                 value={selected?.discountValue ? inr(selected?.discountValue) : "—"}
//               />
//               <Detail label="Final Amount" value={inr(selected?.finalAmount)} />
//               <Detail
//                 label="Booked On"
//                 value={formatDT(selected?.createdAt, { withTime: true, mode: "localIST" })}
//               />
//             </div>

//             <div className="mt-6 flex justify-end gap-3 flex-wrap">
//               <button
//                 onClick={() => setSelected(null)}
//                 className="rounded-full border border-slate-300 px-5 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100"
//               >
//                 Close
//               </button>
//               {(selected?.bookingStatus || "").toLowerCase() === "confirmed" && (
//                 <button
//                   onClick={() =>
//                     downloadTicketPDF(
//                       selected?.bookingCode,
//                       selected?.eventId?.name
//                     )
//                   }
//                   className="rounded-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 px-5 py-2 text-sm font-semibold text-white shadow"
//                 >
//                   Download Ticket
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /* Small component */
// function Detail({ label, value }) {
//   return (
//     <div className="bg-amber-50/50 border border-amber-100 rounded-lg p-3 min-w-0">
//       <p className="text-[10px] md:text-[11px] font-semibold text-amber-800 uppercase tracking-wide">
//         {label}
//       </p>
//       <p className="font-medium text-slate-900 mt-1 break-words">{value || "—"}</p>
//     </div>
//   );
// }


import React, { useEffect, useState, useCallback } from "react";
import { get, post } from "../../../lib/http";
import { API } from "../../../config/api.js";
import ReactPaginate from "react-paginate";
import FancyLoader from "../../../components/FancyLoader.jsx";
import {
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaDownload,
  FaInfoCircle,
  FaSearch,
  FaTimes,
  FaRegCopy,
  FaCheck,
  FaTicketAlt,
} from "react-icons/fa";
import { AD } from "../../adminUi.js";

const cn = (...a) => a.filter(Boolean).join(" ");

/* ---------------- helpers ---------------- */
const inr = (n) => (typeof n === "number" ? `₹${n.toLocaleString("en-IN")}` : n || "—");
const TZ = "Asia/Kolkata";

function formatDT(
  iso,
  { mode = "preserveBackendWallTime", withTime = true, keepCalendarDate = false } = {}
) {
  if (!iso) return "—";
  const d = new Date(iso);

  if (keepCalendarDate) {
    // Date shown in UTC calendar (backend), time shown in IST
    const date = new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
    }).format(d);

    if (!withTime) return date;

    const time = new Intl.DateTimeFormat("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: TZ,
    }).format(d);

    return `${date} • ${time}`;
  }

  // Default behavior: both parts same zone per mode
  const timeZone = mode === "localIST" ? TZ : "UTC";

  const date = new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone,
  }).format(d);

  if (!withTime) return date;

  const time = new Intl.DateTimeFormat("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone,
  }).format(d);

  return `${date} • ${time}`;
}

function downloadBlob(blob, filenameFallback = "file.bin") {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filenameFallback;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
function b64toBlob(b64, type) {
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type });
}

/* ---------------- icon (ticket) ---------------- */
function TicketIcon({ className = "h-6 w-6" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16v4a2 2 0 0 1 0 4v4H4v-4a2 2 0 0 1 0-4V4z" />
      <path d="M8 4v16M16 4v16" />
    </svg>
  );
}

export default function AllBookingList() {
  const [bookings, setBookings] = useState([]);
  const [selected, setSelected] = useState(null);

  // Pagination
  const [page, setPage] = useState(1); // 1-based
  const [limit] = useState(12);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  // Search
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Copy state map to show "copied" feedback per booking
  const [copiedMap, setCopiedMap] = useState({});

  // Debounce search input (450ms)
  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchTerm.trim()), 450);
    return () => clearTimeout(t);
  }, [searchTerm]);

  // Reset to page 1 whenever user changes search (immediate)
  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  const fetchBookings = useCallback(async () => {
    setLoading(true);
    setErrMsg("");
    try {
      const raw = localStorage.getItem("bb_user");
      const parsed = raw ? JSON.parse(raw) : null;
      const userId = parsed?.id ?? null;
      const token = parsed?.token ?? null;

      if (!userId) {
        setBookings([]);
        setTotal(0);
        setTotalPages(1);
        setErrMsg("User not logged in.");
        setLoading(false);
        return;
      }

      // Build URL with pagination and optional search (q)
      const qParam = debouncedSearch ? `&q=${encodeURIComponent(debouncedSearch)}` : "";
      const url = `${API.booking.getAllBooking}?page=${page}&limit=${limit}&paginate=true${qParam}`;

      const res = await get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      });

      console.log(res, "fetchBookings response");
      const arr = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      const meta = res?.meta || (res?.data?.meta ? res.data.meta : {});

      const totalFromMeta =
        Number(meta.total) || (Array.isArray(res) ? res.length : arr.length || 0);
      const totalPagesFromMeta =
        Number(meta.totalPages) || Math.max(1, Math.ceil(totalFromMeta / limit));
      const pageFromMeta = Number(meta.page) || page;

      setBookings(arr);
      setTotal(totalFromMeta);
      setTotalPages(totalPagesFromMeta);
      if (pageFromMeta !== page) setPage(pageFromMeta);
    } catch (e) {
      console.error("fetchBookings error:", e);
      setBookings([]);
      setTotal(0);
      setTotalPages(1);
      setErrMsg(e?.message || "Failed to load bookings.");
    } finally {
      setLoading(false);
    }
  }, [page, limit, debouncedSearch]);

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    if (newPage !== page) setPage(newPage);
  };

  async function downloadTicketPDF(bookingCode, eventName) {
    try {
      const token = JSON.parse(localStorage.getItem("bb_user") || "{}").token ?? null;
      const newUrl = import.meta.env.VITE_API_BASE_URL;
      const url = `${newUrl}/api/ticket/downloadTicketsAsPDF/${encodeURIComponent(
        bookingCode
      )}`;
      const resp = await fetch(url, {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (!resp.ok) {
        const msg = await resp.text().catch(() => "");
        throw new Error(`HTTP ${resp.status} ${msg}`);
      }
      const ct = (resp.headers.get("content-type") || "").toLowerCase();
      let blob;
      if (ct.includes("application/pdf")) blob = await resp.blob();
      else if (ct.includes("application/json")) {
        const data = await resp.json().catch(() => ({}));
        if (data?.pdfBase64) blob = b64toBlob(data.pdfBase64, "application/pdf");
        else if (data?.url) {
          window.location.href = data.url;
          return;
        } else throw new Error("JSON received but no pdfBase64/url.");
      } else blob = await resp.blob();

      const safeEvent = (eventName || "ticket").replace(/\s+/g, "-").slice(0, 50);
      downloadBlob(blob, `${safeEvent}-${bookingCode}.pdf`);
    } catch (err) {
      console.error("PDF download error:", err);
      alert(err?.message || "Could not download PDF. Please try again.");
    }
  }

  // Copy booking code to clipboard with small UI feedback
  const copyBookingCode = async (code, id) => {
    try {
      if (!code) return;
      await navigator.clipboard.writeText(code);
      setCopiedMap((m) => ({ ...m, [id]: true }));
      setTimeout(() => {
        setCopiedMap((m) => {
          const copy = { ...m };
          delete copy[id];
          return copy;
        });
      }, 1800);
    } catch (e) {
      console.error("copy failed", e);
    }
  };

  /* ---------- NEW: updateRefundStatus ---------- */

  const updateRefundStatus = async (bookingId, newStatus) => {
    if (!bookingId) return;
    const confirmMsg = `Change refund status to "${newStatus}"?`;
    if (!window.confirm(confirmMsg)) return;

    // store previous state for rollback
    const prevBookings = bookings.slice();
    const prevSelected = selected ? { ...selected } : null;

    // optimistic update: update bookings array & selected
    setBookings((cur) =>
      cur.map((b) =>
        b._id === bookingId || b.id === bookingId
          ? { ...b, refundStatus: newStatus }
          : b
      )
    );
    if (selected && (selected._id === bookingId || selected.id === bookingId)) {
      setSelected((s) => ({ ...s, refundStatus: newStatus }));
    }

    try {
      const raw = localStorage.getItem("bb_user");
      const parsed = raw ? JSON.parse(raw) : null;
      const token = parsed?.token ?? null;

      // --- build endpoint robustly ---
      let endpoint = "";
      // 1) if API.booking.refundBooking is a function (e.g. (id) => `/bookings/${id}/refund`)
      if (API?.booking && typeof API.booking.refundBooking === "function") {
        endpoint = API.booking.refundBooking(bookingId);
      } else if (API?.booking && typeof API.booking.refundBooking === "string") {
        // string may contain :bookingId placeholder
        endpoint = API.booking.refundBooking.replace(":bookingId", encodeURIComponent(bookingId));
      } else if (API?.booking && typeof API.booking.getAllBooking === "string") {
        // fallback: append /refund or /refunds/:id
        const base = API.booking.getAllBooking.replace(/\/+$/, "");
        endpoint = `${base}/refund/${encodeURIComponent(bookingId)}`;
      } else {
        // last fallback — use conventional route
        endpoint = `/api/bookings/${encodeURIComponent(bookingId)}/refund`;
      }

      // Use PUT (server code expects update). Change to POST if your server expects POST.

      const resp = await post(endpoint, {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ refundStatus: newStatus }),
      });

      if (!resp.ok) {
        const text = await resp.text().catch(() => "");
        throw new Error(`Server responded ${resp.status}: ${text}`);
      }

      // parse JSON if any
      const respJson = await resp.json().catch(() => null);
      console.log("updateRefundStatus parsed body:", respJson);

    
      let serverBooking = null;
      if (respJson) {
        if (respJson.booking) serverBooking = respJson.booking;
        else if (respJson.data && respJson.data.booking) serverBooking = respJson.data.booking;
        else if (respJson.data && respJson.data.booking === undefined && typeof respJson.data === "object" && (respJson.data._id || respJson.data.id)) {
          // maybe data is booking itself
          serverBooking = respJson.data;
        } else if (respJson._id || respJson.id || respJson.refundStatus) {
          serverBooking = respJson;
        }
      }

      if (serverBooking) {
        setBookings((cur) =>
          cur.map((b) =>
            b._id === bookingId || b.id === bookingId ? { ...b, ...serverBooking } : b
          )
        );
        if (selected && (selected._id === bookingId || selected.id === bookingId)) {
          setSelected((s) => ({ ...s, ...serverBooking }));
        }
      } else {
        // if server didn't return the booking, optionally re-fetch or trust optimistic update
        console.log("Server didn't return booking object; keeping optimistic update");
      }
    } catch (err) {
      console.error("updateRefundStatus error:", err);
      alert("Failed to update refund status. Reverting changes.");
      // rollback: restore previous arrays/state
      setBookings(prevBookings);
      if (prevSelected) setSelected(prevSelected);
    }
  };

  /* ---------- end new ---------- */

  return (
    <div className={cn(AD.formWrapWide, AD.page)}>
      <style>{`
        .fade-in { animation: fadeIn .45s ease both; }
        @keyframes fadeIn { from { opacity:.0; transform: translateY(6px) } to { opacity:1; transform: translateY(0) } }
      `}</style>

      <div className={AD.headerRow}>
        <div>
          <nav className="mb-1 flex items-center gap-1.5 text-xs text-slate-500">
            <span>Admin</span>
            <span>/</span>
            <span className="font-medium text-slate-700">All bookings</span>
          </nav>
          <h1 className={AD.title}>All bookings</h1>
          <p className={AD.subtitle}>Browse and download tickets for confirmed bookings.</p>
        </div>
        <div className={cn(AD.statCard, "flex items-center gap-3 px-4 py-3")}>
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 text-white">
            <FaTicketAlt className="text-sm" />
          </span>
          <div>
            <p className="text-xs text-slate-500">Total bookings</p>
            <p className="text-xl font-bold text-slate-900">{total}</p>
          </div>
        </div>
      </div>

      <div className={AD.filterCard}>
        <label className={AD.fieldLabel}>Search</label>
        <div className="relative mt-1">
          <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Event, booking code, venue…"
            className={cn(AD.inputField, "pl-10 pr-10")}
          />
          {searchTerm && (
            <button
              type="button"
              onClick={() => setSearchTerm("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
              aria-label="Clear search"
            >
              <FaTimes />
            </button>
          )}
        </div>
      </div>

      <div className="flex items-start gap-3 rounded-2xl border border-amber-200/80 bg-amber-50/60 px-4 py-3 text-sm text-slate-700">
        <FaInfoCircle className="mt-0.5 shrink-0 text-amber-600" />
        <p>
          Confirmed bookings include a PDF download button.
          {debouncedSearch ? (
            <span className="mt-1 block text-xs text-slate-500">
              Results for &ldquo;<strong>{debouncedSearch}</strong>&rdquo;
            </span>
          ) : null}
        </p>
      </div>

      <div>

        {/* Loader */}
        {loading && (
          <div className="py-20 text-center">
            <FancyLoader label="Loading bookings…" />
          </div>
        )}

        {/* Error */}
        {errMsg && !loading && (
          <div className="mb-6 bg-rose-50/90 border border-rose-200 text-rose-700 rounded-2xl p-4">
            {errMsg}
          </div>
        )}

        {/* Grid */}
        {!loading && !!bookings.length && (
          <div
            className="
              grid gap-4 md:gap-6
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              xl:[grid-template-columns:repeat(4,minmax(0,1fr))]
            "
          >
            {bookings.map((b, idx) => {
              const status = b?.bookingStatus || "—";
              const confirmed = status?.toLowerCase() === "confirmed";
              const img = b?.eventId?.imageUrl || "";
              const title = b?.eventId?.name || "Untitled Event";
              const venue = b?.eventId?.venue?.name || "";
              const city = b?.eventId?.venue?.city || "";
              const state = b?.eventId?.venue?.state || "";
              // Prefer event date from backend (no shift)
              const eventDate = b?.eventId?.date || b?.eventDate || b?.createdAt;
              const bookingCode = b?.bookingCode || "—";
              const idKey = b?._id || b?.id || bookingCode || idx;

              return (
                <article
                  key={idKey}
                  className="group bg-white rounded-2xl border border-slate-200/70 shadow-sm hover:shadow-xl transition-all overflow-hidden fade-in"
                  style={{ animationDelay: `${idx * 35}ms` }}
                >
                  {/* Image: use aspect to prevent jumpy heights on zoom */}
                  <div className="relative w-full aspect-video overflow-hidden bg-gray-900">
                    {img ? (
                      <img
                        src={img}
                        alt={title}
                        className="h-full w-full object-contain"
                      />
                    ) : (
                      <div className="h-full w-full bg-gradient-to-br from-amber-100 to-yellow-100" />
                    )}
                    <div className="absolute inset-x-0 top-0 h-10 bg-gradient-to-b from-black/20 to-transparent" />
                    <div className="absolute left-3 top-3 px-2.5 py-1 rounded-full text-[11px] font-semibold text-amber-900 bg-amber-300/90 border border-amber-400 shadow-sm">
                      {status}
                    </div>
                  </div>

                  <div className="p-4 flex flex-col gap-2 min-w-0">
                    <h3 className="font-semibold text-slate-900 leading-snug line-clamp-1">
                      {title}
                    </h3>

                    {/* Booking Code (inline) */}
                    <div className="flex items-center gap-2 text-xs text-slate-600 mt-1">
                      <div className="font-mono text-[12px] text-slate-700 truncate">
                        {bookingCode}
                      </div>
                      <button
                        onClick={() => copyBookingCode(bookingCode, idKey)}
                        className="ml-1 inline-flex items-center gap-2 text-[11px] text-slate-500 hover:text-slate-800"
                        title="Copy booking code"
                      >
                        {copiedMap[idKey] ? (
                          <span className="inline-flex items-center gap-1 text-emerald-600">
                            <FaCheck /> Copied
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-1">
                            <FaRegCopy /> Copy
                          </span>
                        )}
                      </button>
                    </div>

                    <div className="text-xs text-slate-600 flex items-center gap-2 min-w-0 mt-2">
                      <FaMapMarkerAlt className="text-amber-600 shrink-0" />
                      <span className="truncate">
                        {venue}
                        {venue && (city || state) ? " — " : ""}
                        {city}
                        {city && state ? ", " : ""}
                        {state}
                      </span>
                    </div>

                    {/* DATE: keep backend calendar day, show time in IST */}
                    <div className="text-xs text-slate-600 flex items-center gap-2 min-w-0">
                      <FaCalendarAlt className="text-amber-600 shrink-0" />
                      <span className="truncate">
                        {formatDT(eventDate, { withTime: true, keepCalendarDate: true })}
                      </span>
                    </div>

                    <div className="mt-2 flex items-center justify-between gap-3 flex-wrap">
                      <div className="text-sm font-bold text-slate-900">
                        {inr(b?.finalAmount)}
                      </div>

                      <div className="flex items-center gap-2 flex-wrap">
                        {confirmed && (
                          <button
                            onClick={() => downloadTicketPDF(b?.bookingCode, title)}
                            className="px-3 py-1.5 rounded-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white text-xs font-semibold shadow"
                            title="Download Ticket PDF"
                          >
                            <span className="inline-flex items-center gap-1">
                              <FaDownload /> PDF
                            </span>
                          </button>
                        )}
                        <button
                          onClick={() => setSelected(b)}
                          className="px-3 py-1.5 rounded-full border border-slate-200 hover:border-amber-300 bg-white hover:bg-amber-50 text-xs font-semibold text-slate-700"
                        >
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        )}

        {/* Empty */}
        {!loading && !bookings.length && !errMsg && (
          <div className="bg-white border rounded-2xl p-6 md:p-10 text-center text-slate-600">
            <div className="text-5xl md:text-6xl mb-3">🎟️</div>
            <p className="font-semibold text-slate-800">No bookings found</p>
            <p className="text-xs md:text-sm mt-1">
              When you book an event, it will show up here.
            </p>
          </div>
        )}

        {/* Pagination (wrap on zoom) */}
        {!loading && totalPages > 1 && (
          <div className="mt-8">
            <ReactPaginate
              breakLabel="…"
              nextLabel={
                <span className="px-3 py-2 rounded-lg border border-slate-200 bg-white hover:bg-amber-50 hover:border-amber-200 text-sm">
                  Next ›
                </span>
              }
              previousLabel={
                <span className="px-3 py-2 rounded-lg border border-slate-200 bg-white hover:bg-amber-50 hover:border-amber-200 text-sm">
                  ‹ Prev
                </span>
              }
              onPageChange={handlePageChange}
              forcePage={Math.max(0, Math.min(totalPages - 1, page - 1))}
              pageRangeDisplayed={5}
              marginPagesDisplayed={1}
              pageCount={totalPages}
              containerClassName="flex items-center justify-center gap-1 md:gap-2 select-none flex-wrap"
              pageClassName="group"
              pageLinkClassName="px-3 py-2 rounded-lg border border-slate-200 bg-white hover:bg-amber-50 hover:border-amber-200 transition-colors text-sm font-medium"
              breakClassName="px-2 text-sm"
              activeClassName="selected"
            />
            <style>{`.selected a{background:#f59e0b!important;color:#fff!important;border-color:#f59e0b!important}`}</style>
            <div className="mt-3 text-center text-xs text-slate-500">
              Page {page} of {totalPages} • {total} total
            </div>
          </div>
        )}
      </div>

      {/* Modal */}
      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-3 md:p-4">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setSelected(null)}
          />
          <div
            className="
              relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl
              p-4 md:p-6
              max-h-[85vh] overflow-y-auto
            "
          >
            <button
              onClick={() => setSelected(null)}
              className="absolute top-3 right-3 text-slate-400 hover:text-slate-900"
              aria-label="Close"
            >
              ✕
            </button>

            <div className="flex items-start gap-4 mb-6 min-w-0">
              <div className="w-36 md:w-40 shrink-0">
                <div className="w-full aspect-video overflow-hidden rounded-lg">
                  <img
                    src={selected?.eventId?.imageUrl}
                    alt={selected?.eventId?.name}
                    className="h-full w-full object-contain"
                  />
                </div>
              </div>

              <div className="min-w-0 flex-1">
                <h2 className="text-lg md:text-xl font-bold text-slate-900 truncate">
                  {selected?.eventId?.name}
                </h2>
                <p className="text-xs md:text-sm text-slate-600 flex items-center gap-2 mt-1 min-w-0">
                  <FaMapMarkerAlt className="text-amber-600 shrink-0" />
                  <span className="truncate">
                    {selected?.eventId?.venue?.name}
                    {selected?.eventId?.venue?.name &&
                      (selected?.eventId?.venue?.city ||
                        selected?.eventId?.venue?.state)
                      ? " — "
                      : ""}
                    {selected?.eventId?.venue?.city}
                    {selected?.eventId?.venue?.city &&
                      selected?.eventId?.venue?.state
                      ? ", "
                      : ""}
                    {selected?.eventId?.venue?.state}
                  </span>
                </p>
                {/* DATE in modal header: same rule */}
                <p className="text-[11px] md:text-xs text-slate-500 mt-1 flex items-center gap-2 min-w-0">
                  <FaCalendarAlt className="text-amber-600 shrink-0" />
                  <span className="truncate">
                    {formatDT(selected?.eventId?.date, {
                      withTime: true,
                      keepCalendarDate: true,
                    })}
                  </span>
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 text-sm">
              <Detail label="Booking Code" value={selected?.bookingCode} />
              <Detail label="Booking Status" value={selected?.bookingStatus} />
              <Detail label="Payment Status" value={selected?.paymentStatus} />
              <Detail label="Refund Status" value={selected?.refundStatus} />
              <Detail label="Payment Mode" value={selected?.paymentMode} />
              <Detail
                label="Tickets"
                value={selected?.ticketCategories
                  ?.map((t) =>
                    `${t?.quantity} x ${typeof t?.categoryId === "string"
                      ? t?.categoryId
                      : t?.categoryId?.name || ""
                    }`
                  )
                  .join(", ")}
              />
              <Detail label="Total Amount" value={inr(selected?.totalAmount)} />
              <Detail label="GST" value={inr(selected?.gstAmount)} />
              <Detail label="Convenience Fee" value={inr(selected?.convenienceFee)} />
              <Detail
                label="Discount"
                value={selected?.discountValue ? inr(selected?.discountValue) : "—"}
              />
              <Detail label="Final Amount" value={inr(selected?.finalAmount)} />
              <Detail
                label="Booked On"
                value={formatDT(selected?.createdAt, { withTime: true, mode: "localIST" })}
              />
            </div>

            {/* ---------- NEW: Refund controls ---------- */}
            <div className="mt-5 md:mt-6 bg-slate-50/80 border border-slate-100 rounded-lg p-4">
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div>
                  <p className="text-xs text-slate-500">Refund controls</p>
                  <p className="text-sm font-semibold text-slate-900">{selected?.bookingCode}</p>
                </div>

                <div className="flex items-center gap-3">
                  <select
                    value={(selected?.refundStatus || "requested").toLowerCase()}
                    onChange={(e) => {
                      const val = e.target.value;
                      // call the updater. We update by booking id (selected._id)
                      updateRefundStatus(selected?._id || selected?.id, val);
                    }}
                    className="rounded-full border border-slate-200 px-3 py-1 text-sm bg-white"
                  >
                    <option value="requested">Requested</option>
                    <option value="processing">Processing</option>
                    <option value="refunded">Refunded</option>
                    <option value="rejected">Rejected</option>
                    <option value="failed">Failed</option>
                  </select>

                  <button
                    onClick={() => updateRefundStatus(selected?._id || selected?.id, "refunded")}
                    className="rounded-full bg-emerald-600 px-3 py-1 text-sm font-semibold text-white hover:bg-emerald-500"
                  >
                    Mark refunded
                  </button>
                </div>
              </div>
            </div>
            {/* ---------- END new ---------- */}

            <div className="mt-6 flex justify-end gap-3 flex-wrap">
              <button
                onClick={() => setSelected(null)}
                className="rounded-full border border-slate-300 px-5 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100"
              >
                Close
              </button>
              {(selected?.bookingStatus || "").toLowerCase() === "confirmed" && (
                <button
                  onClick={() =>
                    downloadTicketPDF(
                      selected?.bookingCode,
                      selected?.eventId?.name
                    )
                  }
                  className="rounded-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 px-5 py-2 text-sm font-semibold text-white shadow"
                >
                  Download Ticket
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* Small component */
function Detail({ label, value }) {
  return (
    <div className="bg-amber-50/50 border border-amber-100 rounded-lg p-3 min-w-0">
      <p className="text-[10px] md:text-[11px] font-semibold text-amber-800 uppercase tracking-wide">
        {label}
      </p>
      <p className="font-medium text-slate-900 mt-1 break-words">{value || "—"}</p>
    </div>
  );
}
